import React, { useState } from 'react'
import clsx from 'clsx'

import ActionMenu from '../ActionMenu'

export type ButtonGroupProps = {
	items: React.ReactNode[]
	overflowLimit?: number
	className?: string
}

const ButtonGroup = ({
	items,
	overflowLimit = 0,
	className,
}: ButtonGroupProps) => {
	const [isActionMenuOpen, setIsActionMenuOpen] = useState(false)

	const handleOpenActionMenu = () => {
		setIsActionMenuOpen(true)
	}

	const handleCloseActionMenu = () => {
		setIsActionMenuOpen(false)
	}

	const visibleItems = items.slice(0, overflowLimit)
	const hiddenItems = items.slice(overflowLimit)

	return (
		<div className={clsx('flex gap-2 items-center', className)}>
			{visibleItems}
			{hiddenItems.length > 0 && (
				<ActionMenu
					open={isActionMenuOpen}
					onOpen={handleOpenActionMenu}
					onClose={handleCloseActionMenu}
				>
					{hiddenItems}
				</ActionMenu>
			)}
		</div>
	)
}

export default ButtonGroup
